export default __webpack_public_path__ + "static/media/road_img_5_7.99cd25f8.jpg";